import { render, staticRenderFns } from "./CoBrandedPagePageUrl.vue?vue&type=template&id=212da7f0&"
import script from "./CoBrandedPagePageUrl.vue?vue&type=script&lang=js&"
export * from "./CoBrandedPagePageUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports